import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonToolbar } from 'reactstrap';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import validate from './validate';

const renderFieldTodo = ({
  input, placeholder, type, meta: { touched, error },
}) => (
  <div className="form__form-group-input-wrap">
    <input {...input} placeholder={placeholder} type={type} />
    {touched && error && <span className="form__form-group-error">{error}</span>}
  </div>
);

renderFieldTodo.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderFieldTodo.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const renderDatePicker = ({ dueDate, handleDateChange }) => (
  <DatePicker
    dateFormat="MM/dd/yyyy"
    selected={dueDate}
    onChange={handleDateChange}
    minDate={new Date()}
  />
);

renderDatePicker.propTypes = {
  handleDateChange: PropTypes.func.isRequired,
  dueDate: PropTypes.shape().isRequired,
};

const ItemEditModalForm = ({
  handleSubmit, dueDate, handlePriorityChange, priority,
  handleDateChange, currentEditItem, changeShowEditModal, priorityOptions,
}) => (
  <form className="form" onSubmit={handleSubmit}>
    <div className="form__form-group">
      <span className="form__form-group-label typography-message">Titulo</span>
      <div className="form__form-group-field">
        <Field
          name="title"
          type="text"
          component={renderFieldTodo}
          placeholder="Titulo..."
          required
        />
      </div>
    </div>
    <div className="form__form-group">
      <span className="form__form-group-label">Descripción</span>
      <div className="form__form-group-field">
        <Field
          component="textarea"
          name="description"
          placeholder="¿Que harás..."
        />
      </div>
    </div>
    <div className="form__form-group">
      <span className="form__form-group-label">Fecha</span>
      <div className="form__form-group-field priority">
        <Field
          name="dueDate"
          type="text"
          dueDate={dueDate}
          handleDateChange={handleDateChange}
          component={renderDatePicker}
          required
        />
      </div>
    </div>
    <div className="form__form-group">
      <span className="form__form-group-label">Prioridad</span>
      <div className="form__form-group-field">
        <Select
          className="react-select"
          classNamePrefix="react-select"
          onChange={handlePriorityChange}
          options={priorityOptions}
          defaultValue={priority}
          clearable={false}
        />
      </div>
    </div>
    <ButtonToolbar className="form__button-toolbar">
      <Button color="primary" type="submit">
        {!currentEditItem ? 'Agregar' : 'Editar'}
      </Button>
      <Button type="button" onClick={changeShowEditModal}>Cancelar</Button>
    </ButtonToolbar>
  </form>
);

ItemEditModalForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  changeShowEditModal: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handlePriorityChange: PropTypes.func.isRequired,
  currentEditItem: PropTypes.shape(),
  dueDate: PropTypes.shape().isRequired,
  priority: PropTypes.shape().isRequired,
  priorityOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

ItemEditModalForm.defaultProps = {
  currentEditItem: null,
};

export default reduxForm({
  form: 'todoItemEditModal',
  validate,
})(ItemEditModalForm);
